import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useAdminDefcon() {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchAdminDefcon() {
    setLoading(true);

    const { response, data } = await API.admin.fetchDefcon(token);

    if (response.ok) {
      setResult(data);
      setError(null);
    } else {
      setResult(null);
      setError(data.message);
    }

    setLoading(false);
  }

  useEffect(() => {
    fetchAdminDefcon();
  }, [token]);

  return {
    loading,
    error,
    refresh: fetchAdminDefcon,
    level: result?.level,
  };
}
